import React from 'react'

const NoResults = props => (
  <div className='no-results'>
    <br />
    <h3>Não foram encontrados profissionais para os parâmetros informados</h3>
    <h2>
      <a href={`${process.env.VITTUDE_VIRTUAL_URL}/busca`}>Falar com um psicólogo online</a> do
      conforto da sua casa.
    </h2>
  </div>
)

export default NoResults
